// extracted by mini-css-extract-plugin
export default {"pane":"applications-components-HeaderApp-components-Pane-pane-module__pane","left":"applications-components-HeaderApp-components-Pane-pane-module__left"};
    if(module.hot) {
      // 1782397803604
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  